<template>
  <div class="Popup">
    <saved-item-information
      v-if="!hasSavedItemData"
      :saved-item-info="savedItem"
    />
    <keep-alive>
      <component
        :is="authorisationForm"
        :email-only="emailOnly"
        :short-list-info="savedItem"
        :import-comment="importComment"
      />
    </keep-alive>
  </div>
</template>

<script>
import ModalLoginForm from '@/components/modal/modal-authentication-forms/modal-login-form.vue';
import ModalRegisterForm from '@/components/modal/modal-authentication-forms/modal-register-form.vue';
import SavedItemInformation from '@/components/modal/modal-content/saved-item-information.vue';

export default {
  components: {
    SavedItemInformation,
    ModalLoginForm,
    ModalRegisterForm,
  },
  props: {
    savedItem: {
      type: Object,
      default: null,
    },
    importComment: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      showModal: false,
      authorisationForm: ModalLoginForm,
      emailOnly: false,
    };
  },
  computed: {
    hasSavedItemData() {
      if (this.savedItem.type !== null) {
        return false;
      }
      return true;
    },
  },
  created() {
    // Emitted when switching from register or login form in the saved item modal when not logged in.
    this.$bus.$on('bus:authentication:show-register-form', this.switchToRegisterForm);
    this.$bus.$on('bus:authentication:show-login-form', this.switchToLoginForm);
  },
  beforeDestroy() {
    this.$bus.$off('bus:authentication:show-register-form', this.switchToRegisterForm);
    this.$bus.$off('bus:authentication:show-login-form', this.switchToLoginForm);
  },
  methods: {
    switchToLoginForm() {
      this.authorisationForm = ModalLoginForm;
    },
    switchToRegisterForm() {
      this.authorisationForm = ModalRegisterForm;
    },
  },
};
</script>
